import * as React from "react";
import type { SVGProps } from "react";

const SvgDental = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 48 48" {...props}>
    <path
      fill="#142745"
      d="M36.83 22.92a9.9 9.9 0 0 1-2.42-2.6c-1.7-2.2-3.62-4.7-5.69-4.7A5.77 5.77 0 0 0 24 18a6.14 6.14 0 0 0-4.39-2.16c-1.75 0-3.88 2.5-5.75 4.71a11.6 11.6 0 0 1-2.65 2.66.27.27 0 0 0 0 .5 10.9 10.9 0 0 1 2.95 3c1.52 1.89 3.25 4 5.55 4.92a12.6 12.6 0 0 0 4.59.8 25 25 0 0 0 4.38-.46c2-.37 5.09-4.42 6.91-6.84a16 16 0 0 1 1.34-1.67.27.27 0 0 0 .13-.25.26.26 0 0 0-.23-.29m-2.83.79a18 18 0 0 1-9.09 2.65 18.8 18.8 0 0 1-10.3-2.49 10.9 10.9 0 0 0 2.82-1.22 5.65 5.65 0 0 1 2.58-1 9.4 9.4 0 0 1 2.89.61 4.8 4.8 0 0 0 1.57.36 7 7 0 0 0 1.34-.32 10.1 10.1 0 0 1 2.79-.54 7.1 7.1 0 0 1 2.54.86A11.4 11.4 0 0 0 34 23.71"
    />
  </svg>
);
export default SvgDental;
